import { Grid, Box, Typography } from "@mui/material";
import ReportExplanation from "./ReportExplanation";
import { ExamQuestionModel } from "../../Utils/Models";
import { isMobile } from "../../Utils/Utils";

export default function ExamExplanation({
  isCorrect,
  question,
}: {
  isCorrect: boolean | null;
  question?: ExamQuestionModel;
}) {
  const explanation = question?.explanation;
  if (isCorrect === null) return null;
  return (
    <Grid container justifyContent="center" mt={3} mb={3}>
      <Grid item xs={12} md={10}>
        <Box
          bgcolor="#f8f9fa"
          borderRadius={2}
          p={3}
          mt={2}
          textAlign="center"
          border={isCorrect ? "1px solid #4caf50" : "1px solid #f44336"}
        >
          <div
            style={{
              display: isMobile() ? "block" : "flex",
              justifyContent: "space-between",
            }}
          >
            <ReportExplanation question={question} />
            <Typography
              variant="h6"
              color={isCorrect ? "success.main" : "error.main"}
              gutterBottom
            >
              {isCorrect ? "Corect!" : "Răspunsul tău nu este corect!"}
            </Typography>
          </div>
          {explanation && (
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ whiteSpace: "pre-line" }}
            >
              Explicație: {explanation}
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}
